import { arrayToObject } from '@/@core/utils/utils'

export const TRIP_TYPE_OPTIONS = [
  // D hoặc A (D: chuyến bay đi, A: chuyến bay đến)
  { label: 'Departure', value: 'D' },
  { label: 'Arrival', value: 'A' },
]

export const TRIP_TYPE = arrayToObject(TRIP_TYPE_OPTIONS, 'label', 'value')

export const DEPARTURE_HOUR_OPTIONS = [
  { label: 'ALL', value: null },
  { label: '00:00 - 04:00', value: '0 | 4' },
  { label: '04:00 - 08:00', value: '4 | 8' },
  { label: '08:00 - 12:00', value: '8 | 12' },
  { label: '12:00 - 16:00', value: '12 | 16' },
  { label: '16:00 - 20:00', value: '16 | 20' },
  { label: '20:00 - 00:00', value: '20 | 24' },
]

export const tableColumns = [
  { label: 'scheduleTime', key: 'scheduleTime', isHideMobile: true },
  { label: 'estimateTime', key: 'estimateTime' },
  { label: 'airportName', key: 'airportName', isHideMobile: true },
  { label: 'airlineName', key: 'airlineName', isHideMobile: true },
  { label: 'flightNumber', key: 'flightNumber' },
  { label: 'terminal', key: 'terminal', isHideMobile: true },
  { label: 'checkinRow', key: 'checkinRow', isHideMobile: true },
  { label: 'gate', key: 'gate', isHideMobile: true },
  { label: 'remark', key: 'remark' },
  { label: 'action', key: 'action', isOnlyShowMobile: true },
]

export const resolveRemarkVariant = {
  'Hủy chuyến bay': 'light-danger',
  'Đã cất cánh': 'light-success',
  'Đã hạ cánh': 'success',
  'Đang đến': 'light-info',
  'Mở quầy thủ tục': 'light-warning',
  'Lên tàu bay': 'light-warning',
  'Sắp cất cánh': 'light-warning',
  'Sắp hạ cánh': 'light-warning',
  'Chuyến bay đến trễ': 'light-danger',

  // tpv
  // SGN
  'Đóng cửa khởi hành': 'light-warning',
  'Hành khách cuối lên tàu bay': 'light-warning',
  'Hành khách lên tàu bay': 'light-warning',
  'Mời hành khách làm thủ tục': 'light-warning',
  'Đổi cửa khởi hành': 'light-danger',
  'Đến trễ': 'light-danger',
  'Hành khách cuối làm thủ tục': 'light-warning',
  'Ðang trả hành lý': 'light-warning',

  // DAD
  Trễ: 'light-danger',
  'Đang lên máy bay': 'light-warning',
}
